import moment from "moment";
import { FC } from "react";
import { HiOutlineCalendar } from "react-icons/hi";
import { Text, Title } from "rizzui";

interface EmptyStateProps {
    selectedDate: string;
}

const EmptyState: FC<EmptyStateProps> = ({ selectedDate }) => {
    return (
        <div className="bg-white rounded-lg p-8 text-center shadow-sm border">
            <HiOutlineCalendar className="h-12 w-12 text-gray-400 mx-auto mb-4" />
            <Title as="h3" className="text-lg font-medium text-gray-900 mb-2">
                No hay recogidas programadas
            </Title>
            <Text className="text-gray-500">
                No tienes recogidas asignadas para {moment(selectedDate).format('DD/MM/YYYY')}
            </Text>
        </div>
    );
};

export default EmptyState;